module.exports = __webpack_public_path__ + "static/media/heart-icon.0ca9b632.svg";